import '../../../../packages/neb-lit-components/src/components/neb-date-picker';
import '../../../../packages/neb-lit-components/src/components/inputs/neb-textarea';
import '../../../../packages/neb-lit-components/src/components/inputs/neb-select';
import { html, css } from 'lit';

import { BUTTON_ROLE } from '../../../../packages/neb-lit-components/src/components/neb-button';
import NebPopup, {
  ELEMENTS as BASE_ELEMENTS,
} from '../../../../packages/neb-popup/src/neb-popup';
import { CSS_SPACING } from '../../../../packages/neb-styles/neb-variables';

export const ELEMENTS = {
  ...BASE_ELEMENTS,
  selectBilledStatus: {
    id: 'select-billed-status',
  },
  buttonConfirm: {
    id: 'button-confirm',
  },
  buttonCancel: {
    id: 'button-cancel',
  },
};

class NebPopupArHubUpdateBilledStatus extends NebPopup {
  static get properties() {
    return {
      __selectedItem: Object,
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        :host {
          width: 450px;
        }

        .content-container {
          display: flex;
          flex-direction: column;
          flex: 1 0 0;
          justify-content: space-between;
          height: 100%;
        }

        .button-container {
          display: flex;
          justify-content: start;
          margin-top: 30px;
          gap: 10px;
        }

        .spacing {
          margin-right: 10px;
        }

        .padding-top {
          padding-top: ${CSS_SPACING};
        }
      `,
    ];
  }

  initState() {
    super.initState();

    this.title = 'Update Billed Status';
    this.model = {};
    this.__selectedItem = {};
  }

  initHandlers() {
    super.initHandlers();

    this.handlers = {
      change: e => {
        if (e.value && e.value !== this.__selectedItem) {
          this.__selectedItem = e.value;
        }
      },
      save: () => {
        this.onClose(this.__selectedItem.value.id);
      },
      cancel: () => this.onClose(false),
    };
  }

  renderContent() {
    const formattedInvoices = this.model.invoiceNumbers
      .map(num => `#${num}`)
      .join(', ');

    return html`
      <div class="content-container">
        <div>The following invoices will be updated: ${formattedInvoices}</div>
        <neb-select
          id="${ELEMENTS.selectBilledStatus.id}"
          class="padding-top"
          helper="Required"
          .label="Billed Status"
          .items="${this.model.billedStatuses}"
          .value="${this.__selectedItem}"
          .onChange="${this.handlers.change}"
        ></neb-select>
        <div class="button-container">
          <neb-button
            id="${ELEMENTS.buttonConfirm.id}"
            class="button"
            label="Update"
            .role="${BUTTON_ROLE.CONFIRM}"
            .onClick="${this.handlers.save}"
            ?disabled="${!this.__selectedItem.value}"
          ></neb-button>
          <neb-button
            id="${ELEMENTS.buttonCancel.id}"
            class="button"
            label="Cancel"
            .role="${BUTTON_ROLE.OUTLINE}"
            .onClick="${this.handlers.cancel}"
          ></neb-button>
        </div>
      </div>
    `;
  }
}

customElements.define(
  'neb-popup-ar-hub-update-billed-status',
  NebPopupArHubUpdateBilledStatus,
);
